import {AfterContentChecked, Component, OnInit} from '@angular/core';

import {DropdownMenuOption} from 'app/models/dropdown-menu-option';
import {CompetitionService} from 'app/services/competition.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Competition} from 'app/models/competition';
import {DialogHelperService} from '../../services/dialog-helper.service';
import slugify from 'slugify';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    providers: [DialogHelperService]
})
export class AdminComponent implements OnInit {

    options: Array<DropdownMenuOption>;
    selected: DropdownMenuOption;
    competition: Competition;
    editMode: boolean = false;
    newCompetitionName: string;
    newCompetitionUrl: string;
    constructor(
        private competitionService: CompetitionService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private dialogHelper: DialogHelperService,
    ) {}

    ngOnInit() {
        this.competition = this.competitionService.getCompetitionSelected();
        this.getCompetitions();
    }

  onSelectCompetition(event): void {
      if (event.id === this.competition.compUrl) {
        return;
      }
      const competition = this.competitionService.getCompetitionSelectedByUrl(event.id);
      this.competitionService.setCompetitionSelected(competition);
      this.competition = competition;
      this.router.navigate(['competition', event.id, 'onboarding'],
          {relativeTo: this.activatedRoute.parent});
      this.selected = event;
    }

    private getCompetitions(): void {
        const competitions = this.competitionService.getCompetitions();

        if (!this.competition && !!competitions.length) {
            this.competitionService.setCompetitionSelected(competitions[0]);
        } else if (!this.competition) {
            return;
        }

        this.options = this.competitionService.getDropdownMenuOptions();
        this.selected = this.options.filter((option) =>
            option.id === this.competitionService.getCompetitionUrl())[0];
        this.redirectToCompetitionId();
    }

    private redirectToCompetitionId(): void {
        if (this.activatedRoute) {
            this.activatedRoute.params.subscribe((params: Params) => {
                if (!params.id) {
                    this.router.navigate(['competition', this.selected.id, 'onboarding'],
                        {relativeTo: this.activatedRoute.parent});
                }
            });
        }
    }
    onAdd() {}
    onCancel() {
        this.newCompetitionName = undefined;
        this.newCompetitionUrl = undefined;
        this.editMode = !this.editMode;
    }
    onKeydown(event) {
        if (event.key === "Enter") {
            if (this.editMode && this.newCompetitionName && this.newCompetitionName !== this.competition.displayName) {
                this.competition.displayName = this.newCompetitionName;

                this.competitionService.update(this.competition).subscribe(r => {
                    this.competition = r;
                  // Warning: id in options is compUrl param from model
                    this.options.filter((option) =>
                        option.id === r.compUrl)[0].name = r.displayName;
                    this.selected.name = r.displayName;
                    this.competitionService.setCompetitionSelected(r);
                    this.newCompetitionName = undefined;
                    this.editMode=false;
                })

            }
        }
    }
    onKeydownUrl(event) {
      if (event.key === 'Enter') {
        if (this.editMode && this.newCompetitionUrl && this.newCompetitionUrl !== this.competition.compUrl) {
          this.newCompetitionUrl = slugify(this.newCompetitionUrl);
          const oldUrl = this.competition.compUrl;
          this.competition.compUrl = this.newCompetitionUrl;
          this.competitionService.update(this.competition).subscribe(r => {
            this.competition = r;
            // Warning: id in options is compUrl param from model
            this.options.filter((option) =>
              option.id === oldUrl)[0].name = r.displayName;
            this.selected.name = r.displayName;
            this.selected.id = r.compUrl;
            this.competitionService.setCompetitionSelected(r);
            this.newCompetitionUrl = undefined;
            this.editMode = false;
            this.competitionService.getAll(this.selected.id);
            this.router.navigate(['competition', r.compUrl, 'onboarding'],
              {relativeTo: this.activatedRoute.parent});
          }, error => {
            this.newCompetitionUrl = undefined;
            console.log('error on updating competition');
            console.log(error);
            if (!!!error.handled) {
              if (typeof error.error === 'object') {
                this.dialogHelper.showPrompt(
                  'Unable to update competition',
                  error.statusText,
                  'OK',
                  () => {}
                );
              } else {
                this.dialogHelper.showPrompt(
                  'Unable to update competition',
                  error.error,
                  'OK',
                  () => {}
                );
              }
            }
          });

        }
      }
    }
    onSelectChange(event) {
        this.competitionService.update(this.competition).subscribe(r => {
          this.competition = r;
          // Warning: id in options is compUrl param from model
          this.options.filter((option) =>
            option.id === r.compUrl)[0].name = r.displayName;
          this.selected.name = r.displayName;
          this.competitionService.setCompetitionSelected(r);
          this.newCompetitionName = undefined;
          this.editMode=false;
        });
    }
    onPreview() {
        this.router.navigate([this.competitionService.getCompetitionUrl()]);
    }

    onNewCompetition() {
        this.router.navigate(['competition'], {relativeTo: this.activatedRoute.parent});
    }
    onDeleteCompetition() {
        this.competition = this.competitionService.getCompetitionSelected();
        this.competitionService.deleteCompetition(this.competition.id).subscribe(r => {
            this.competitionService.setCompetitionSelected(undefined);
            this.router.navigateByUrl('competition')
        })
    }

    urlChanged() {
      this.newCompetitionUrl = slugify(this.newCompetitionUrl);
    }

}



// WEBPACK FOOTER //
// ./src/app/views/admin/admin.component.ts